module.exports = __webpack_public_path__ + "img/logo_white.ba0c35df.png";